// Templates predefinidos para formularios de etapas

const LOST_REASONS_NACIONAL = [
  'Precio fuera de presupuesto',
  'Falta de financiamiento',
  'Proyecto cancelado',
  'Competencia más económica',
  'Competencia con mejor financiación',
  'Competencia con mejor servicio post-venta o asesoramiento',
  'No le sirven los productos',
  'Faltante de stock',
  'Desconfianza en el producto',
  'Desconfianza en la marca',
  'Mala experiencia previa con Empresa',
  'Logística costosa',
  'Sin respuesta',
  'Falta de seguimiento',
];

const LOST_REASONS_COMEX_EXTRA = [
  'Falta de representante local para postventa',
  'Problemas de pago internacional',
  'Producto no adaptado a normativas locales del cliente',
  'Problemas con tiempos de entrega internacional',
  'Falta de conocimiento del proceso de importación/exportación',
  'Problemas o restricción de importación o aduanas',
];

export const TEMPLATE_WON = {
  enabled: true,
  fields: [
    {
      _uid: 'won_products',
      key: 'products',
      type: 'multiselect',
      label: 'Productos del negocio',
      required: false,
      options: [], // Se cargarán dinámicamente desde la API de productos
      updates_deal_field: 'product_ids',
      help: 'Productos seleccionados en el negocio. Este campo actualizará los productos del deal.',
    },
    {
      _uid: 'won_final_amount',
      key: 'final_amount',
      type: 'number',
      label: 'Monto',
      required: true,
      min: 0,
      step: 0.01,
      updates_deal_field: 'amount_cents',
      help: 'Este monto actualizará el valor del deal',
    },
    {
      _uid: 'won_payment_methods',
      key: 'payment_methods',
      type: 'multiselect',
      label: 'Método de pago',
      required: true,
      options: [
        'Transferencia',
        'Efectivo',
        'Tarjeta de débito',
        'Tarjeta de crédito',
        'QR',
        'Cheque Electrónico',
      ],
      updates_deal_field: 'payment_method_ids',
      help: 'Métodos de pago utilizados. Este campo actualizará los métodos de pago del deal.',
    },
    {
      _uid: 'won_order_number',
      key: 'order_number',
      type: 'text',
      label: 'N° de Orden de Venta',
      placeholder: 'OV-12345',
      required: false,
    },
    {
      _uid: 'won_win_reason',
      key: 'win_reason',
      type: 'multiselect',
      label: 'Motivo ganado',
      required: true,
      options: [
        'Calidad',
        'Precio',
        'Financiación',
        'Stock',
        'Confianza',
        'Referido',
      ],
      allowOther: true,
    },
  ],
};

export const TEMPLATE_LOST = {
  enabled: true,
  fields: [
    {
      _uid: 'lost_lost_reason',
      key: 'lost_reason',
      type: 'multiselect',
      label: 'Motivo No Ganado',
      required: true,
      options: LOST_REASONS_NACIONAL,
      allowOther: true,
      comex_options: [...LOST_REASONS_NACIONAL, ...LOST_REASONS_COMEX_EXTRA],
      help: 'Las opciones se ajustarán automáticamente si el contacto es COMEX (teléfono distinto de +54)',
    },
  ],
};

export const TEMPLATE_PAUSED = {
  enabled: true,
  fields: [
    {
      _uid: 'paused_pause_reason',
      key: 'pause_reason',
      type: 'multiselect',
      label: 'Motivo Pausado',
      required: true,
      options: [
        'Lo quiere pensar',
        'Esperando dinero/crédito',
        'Proyecto diferido',
      ],
      allowOther: true,
    },
    {
      _uid: 'paused_expected_resume_date',
      key: 'expected_resume_date',
      type: 'date',
      label: 'Fecha de reapertura',
      required: false,
      help: 'Fecha estimada en la que se reactivará el negocio',
    },
    {
      _uid: 'paused_expected_close_date',
      key: 'expected_close_date',
      type: 'date',
      label: 'Fecha estimada de cierre',
      required: false,
      updates_deal_field: 'expected_close_date',
      help: 'Esta fecha actualizará el campo fecha estimada de cierre del deal',
    },
  ],
};

export const TEMPLATE_CANCELED = {
  enabled: true,
  fields: [
    {
      _uid: 'canceled_cancel_reason',
      key: 'cancel_reason',
      type: 'select',
      label: 'Motivo de cancelación',
      required: true,
      options: [
        'Negocio duplicado',
        'Contacto equivocado',
        'Spam o falso lead',
        'Cliente no responde tras múltiples intentos',
        'Deal creado por error',
        'Otro',
      ],
      allowOther: true,
    },
    {
      _uid: 'canceled_cancel_reason_other',
      key: 'cancel_reason_other',
      type: 'textarea',
      label: 'Especifique otro motivo',
      placeholder: 'Describa el motivo...',
      required: false,
      conditional_on: {
        field: 'cancel_reason',
        value: 'Otro',
      },
    },
  ],
};

// Mapeo de stage_type a template
export const STAGE_TYPE_TEMPLATES = {
  won: TEMPLATE_WON,
  lost: TEMPLATE_LOST,
  paused: TEMPLATE_PAUSED,
  canceled: TEMPLATE_CANCELED,
};

// Tipos de campo disponibles
export const FIELD_TYPES = [
  { value: 'text', label: 'Texto corto', icon: '📝' },
  { value: 'textarea', label: 'Texto largo', icon: '📄' },
  { value: 'select', label: 'Lista desplegable', icon: '📋' },
  { value: 'multiselect', label: 'Selección múltiple', icon: '☑️' },
  { value: 'number', label: 'Número', icon: '🔢' },
  { value: 'date', label: 'Fecha', icon: '📅' },
  { value: 'checkbox', label: 'Casilla de verificación', icon: '✅' },
];

// Campos del Deal que pueden ser actualizados desde el form
export const UPDATABLE_DEAL_FIELDS = [
  { value: '', label: '-- No actualizar campo del deal --' },
  { 
    value: 'amount_cents', 
    label: '💰 Monto',
    fieldType: 'number',
    readonly: true,
    help: 'Campo tipo número con decimales. Se guardará en centavos en el Deal.'
  },
  { 
    value: 'expected_close_date', 
    label: '📅 Fecha estimada de cierre',
    fieldType: 'date',
    readonly: true,
    help: 'Campo tipo fecha (YYYY-MM-DD)'
  },
  { 
    value: 'payment_method_ids', 
    label: '💳 Métodos de pago',
    fieldType: 'multiselect',
    readonly: true,
    options: [
      'Transferencia',
      'Efectivo',
      'Tarjeta de débito',
      'Tarjeta de crédito',
      'QR',
      'Cheque Electrónico'
    ],
    help: 'Campo tipo multiselect con opciones predefinidas del sistema. Permite múltiples métodos de pago.'
  },
  { 
    value: 'product_ids', 
    label: '📦 Productos del negocio',
    fieldType: 'multiselect',
    readonly: true,
    options: [], // Se cargan dinámicamente desde la API
    dynamic: true,
    help: 'Campo tipo multiselect con productos. Las opciones se cargan dinámicamente desde la API de productos.'
  },
];

// Mapeo de payment_method: índice de array → valor enum del backend
export const PAYMENT_METHOD_OPTIONS_ORDER = [
  'bank_transfer',    // 0 - Transferencia bancaria
  'cash',             // 1 - Efectivo
  'debit_card',       // 2 - Tarjeta de débito
  'credit_card',      // 3 - Tarjeta de crédito
  'qr_code',          // 4 - QR
  'electronic_check'  // 5 - Cheque electrónico
];
